import { useRentalManagerAccountViewZrmListingsWebApiHandler_leads } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';
import type { RentalManagerAccountViewZrmListingsWebApiHandler_leads_Options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

export const useGetListingLeads = (
  listingAlias: ListingAlias,
  options: Partial<RentalManagerAccountViewZrmListingsWebApiHandler_leads_Options> = {},
) => {
  const { data, error, isFetching } = useRentalManagerAccountViewZrmListingsWebApiHandler_leads(
    { listingAlias },
    {
      ...options,
      enabled: Boolean(listingAlias) && (options.enabled ?? true),
      meta: {
        tags: ['getListingLeads', listingAlias],
        context: {
          api: 'useRentalManagerAccountViewZrmListingsWebApiHandler_leads',
          details: 'useGetListingLeads',
        },
      },
    },
  );

  return { data, isFetching, error };
};
